"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _skeleton = require("./skeleton.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Skeleton = function Skeleton(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _skeleton.useStyles)(props);

  var htmlAttributes = _extends({}, props);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: classes.skeleton
  }, htmlAttributes));
};

exports.Skeleton = Skeleton;
Skeleton.propTypes = {
  variant: _propTypes["default"].oneOf(['rect', 'circle']),
  animation: _propTypes["default"].oneOf(['wave', 'pulse', false]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  rounded: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  children: _propTypes["default"].node
};